module.exports = __webpack_public_path__ + "static/media/clear-circle.d9de5d79.svg";